import { CreateInstance } from "./config"
const DeviceListAPI = CreateInstance("devices")
export default DeviceListAPI
